import {
  REQUEST_CCP,
  RECEIVE_CCP,
  CCP_FAILED,
  REQUEST_TPT,
  RECEIVE_TPT,
  TPT_FAILED,
  API_CALL,
  REQUEST_UPLOAD,
  RECEIVE_UPLOAD,
  UPLOAD_FAILED
} from './types';

export const getPresets = () => ({
  type: API_CALL,
  onRequest: REQUEST_CCP,
  onResponse: RECEIVE_CCP,
  onError: CCP_FAILED,
  responseKey: 'ccp',
  payload: {
    method: 'GET',
    url: '/presets'
  }
});

export const getTPTs = () => ({
  type: API_CALL,
  onRequest: REQUEST_TPT,
  onResponse: RECEIVE_TPT,
  onError: TPT_FAILED,
  responseKey: 'tpt',
  payload: {
    method: 'GET',
    url: '/presets/thirdparty'
  }
});

export const uploadTargeting = () => ({
  type: API_CALL,
  onRequest: REQUEST_UPLOAD,
  onResponse: RECEIVE_UPLOAD,
  onError: UPLOAD_FAILED,
  responseKey: 'upload',
  payload: {
    method: 'PUT',
    url: '/presets/upload'
  }
});
